import { ButcherHeader } from '@components/ButcherHeader';
import { SideNav } from '@components/OrderCreation/OrderSideNav';
import { OrderListBreadcrumbs } from '@components/OrderProcessing/OrderListBreadcrumbs';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  AppSettingsSubscriptionSteps,
  OrderProcessingMasterData,
} from '@helpers/Constants';
import { FrontendRoutes } from '@helpers/Constants/Navigation';
import { SubscriptionConfirmation } from '@pages/Subscription/Popup/SubscriptionConfirmation';
import { useNavigate } from 'react-router-dom';

export const ReactivateSubscriptionSuccess = () => {
  const navigate = useNavigate();

  const BreadCrumbsProps = {
    steps: AppSettingsSubscriptionSteps,
    activeItem: 'Subscription',
    type: OrderProcessingMasterData.APP_SETTINGS,
  };

  return (
    <div className="flex h-screen w-screen gap-1">
      {/* Sidebar */}
      <SideNav active={10} />
      {/* Main Content */}
      <div className="flex-1 p-1 overflow-auto relative">
        {/* Header */}
        <ButcherHeader />
        <OrderListBreadcrumbs orderInfo={BreadCrumbsProps} />

        <div className="flex items-center justify-between mt-4 mb-4">
          <div className="flex items-center">
            <button
              type="button"
              onClick={() => navigate(FrontendRoutes.SUBSCRIPTION_DETAILS)}
              className="text-[#1C1B1F] hover:text-primary text-lg mr-2 focus:outline-none"
            >
              <FontAwesomeIcon icon={faAngleLeft} />
            </button>
            <h2 className="text-2xl font-semibold ml-2">
              Reactivate Subscription
            </h2>
          </div>
        </div>

        {/* Main content */}
        <SubscriptionConfirmation isFromAppSettings={true} />
      </div>
    </div>
  );
};
